module.exports = __webpack_public_path__ + "media/24.7_Support_R2.ec821797.mp4";